import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import MultiSelect from "./MultiSelect";
import FormHelperText from "@material-ui/core/FormHelperText";
import { inject, observer } from "mobx-react";
import { reaction } from "mobx";
import _ from "lodash";

const ITEM_REMOVED = "remove-option";
const ALL_ITEMS_REMOVED = "clear";
const ITEM_SELECTED = "select-option";

class SearchClauseInput extends React.Component {
  render() {
    const {
      typeaheadDropDownStore: dropdownStore,
      pitsMetadataStore,
      clauseIdx,
      clause
    } = this.props;

    reaction(
      () => clause.fieldId,
      () => {
        clearAutoCompleteSearchData();
      }
    );

    const clearAutoCompleteSearchData = () => {
      dropdownStore.clearSuggestions();
      dropdownStore.clearPreviousSelections();
    };

    const handleOnInputChange = (value, reason) => {
      if (reason === "input") {
        if (value) {
          dropdownStore.fetchSuggestions(value, clause.fieldId);
        }
      } else if (reason === ALL_ITEMS_REMOVED) {
        // Big X
        clause.resetValues();
        clearAutoCompleteSearchData();
      }
    };
    // the user selected or removed something.
    const handleTypeAheadOnChange = (event, values, detail) => {
      if (detail === ITEM_REMOVED) {
        clause.values = values; // These are the remaining chips
        dropdownStore.resetPreviousSelections(values);
      } else if (detail === ITEM_SELECTED) {
        // add another selection, if we haven't already added it.
        values.forEach(v => {
          const index = _.findIndex(clause.values, function(o) {
            return o.value === v.value;
          });
          if (index === -1) {
            clause.values.push(v);
          }
        });
        dropdownStore.addPreviousSelections(values);
      }
      dropdownStore.clearSuggestions();
    };
    const multiSelectChangeHandler = currentClause => values => {
      currentClause.values = values;
    };
    const isTypeAhead = pitsMetadataStore.isTypeAheadEnabled(clause.fieldId);
    return isTypeAhead ? (
      <React.Fragment>
        <Autocomplete
          multiple
          value={clause.values}
          options={dropdownStore.suggestions}
          getOptionSelected={(option, value) => option.value === value.value}
          getOptionLabel={option =>
            option && option.label ? option.label : ""
          }
          id={`auto-complete-${clause.fieldId}`}
          onInputChange={(event, value, reason) =>
            handleOnInputChange(value, reason)
          }
          onChange={(event, value, detail) =>
            handleTypeAheadOnChange(event, value, detail)
          }
          renderInput={params => (
            <TextField
              {...params}
              onKeyDown={e => e.stopPropagation()}
              helperText={
                clause.hasValueErrors
                  ? clause.valuesErrorMessage
                  : clause.fieldHelperText
              }
              onBlur={() => {
                dropdownStore.clearSuggestions();
              }}
              InputProps={{
                ...params.InputProps,
                type: "search"
              }}
            />
          )}
        />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <MultiSelect
          id={`multi-select-${clauseIdx}`}
          values={clause.values.slice()}
          onChange={multiSelectChangeHandler(clause)}
          options={pitsMetadataStore.fields[clause.fieldId].values.map(f => ({
            label: f.displayValue,
            value: f.value
          }))}
        />
        {clause.hasValuesErrors ? (
          <FormHelperText>{clause.valuesErrorMessage}</FormHelperText>
        ) : (
          <FormHelperText>{clause.fieldHelperText}</FormHelperText>
        )}
      </React.Fragment>
    );
  }
}

export default inject(
  "pitsMetadataStore",
  "typeaheadDropDownStore"
)(observer(SearchClauseInput));



// WEBPACK FOOTER //
// ./src/components/SearchClauseInput.js